/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function GutenbergCTABlock(elem) {
        Behaviors.init(GutenbergCTABlock, this, arguments);

        var $thisElem = this.$elem;


    }
    Behaviors.inherit(GutenbergCTABlock, Behaviors.Behavior);
    GutenbergCTABlock.QUERY = "[data-GutenbergCTABlock]";
    GutenbergCTABlock.ELEMENTS = {
        loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
    };
    Behaviors.register_behavior(GutenbergCTABlock);
    module.GutenbergCTABlock = GutenbergCTABlock;
    return module;
}(window.jQuery, window.Behaviors));